import React, { useState } from 'react';
import { auth, db } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { collection, getDocs } from 'firebase/firestore';

function Login({ onLogin }) {
  const [korak, setKorak] = useState('odabir');
  const [adminEmail, setAdminEmail] = useState('');
  const [adminLozinka, setAdminLozinka] = useState('');
  const [odabraniIgrac, setOdabraniIgrac] = useState('');
  const [pin, setPin] = useState('');
  const [igraci, setIgraci] = useState([]);
  const [greska, setGreska] = useState('');
  const [ucitavanje, setUcitavanje] = useState(false);

  const ucitajIgrace = async () => {
    const snap = await getDocs(collection(db, 'igraci'));
    setIgraci(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  const handleAdminLogin = async () => {
    setGreska('');
    setUcitavanje(true);
    try {
      await signInWithEmailAndPassword(auth, adminEmail, adminLozinka);
      onLogin({ tip: 'admin', ime: 'Admin' });
    } catch (err) {
      setGreska('Pogrešan email ili lozinka!');
    }
    setUcitavanje(false);
  };

  const handleIgracKorak = async () => {
    setUcitavanje(true);
    await ucitajIgrace();
    setKorak('igrac');
    setUcitavanje(false);
  };

  const handleIgracLogin = async () => {
    if (!odabraniIgrac) return setGreska('Odaberi igrača!');
    if (!pin) return setGreska('Upiši PIN!');
    setGreska('');
    setUcitavanje(true);
    try {
      const igrac = igraci.find(i => i.id === odabraniIgrac);
      if (!igrac) { setGreska('Igrač nije pronađen!'); setUcitavanje(false); return; }
      if (igrac.pin !== pin) { setGreska('Pogrešan PIN!'); setUcitavanje(false); return; }
      onLogin({ tip: 'igrac', ime: igrac.ime, igracId: igrac.id, klub: igrac.klub });
    } catch (err) {
      setGreska('Greška pri prijavi!');
    }
    setUcitavanje(false);
  };

  const handleGostLogin = () => {
    onLogin({ tip: 'gost', ime: 'Gost' });
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f0f1a', padding: '20px' }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '56px', marginBottom: '8px' }}>🎳</div>
          <div style={{ fontSize: '24px', fontWeight: '700', color: '#fff' }}>Arena Bakarni</div>
          <div style={{ fontSize: '14px', color: '#666688', marginTop: '4px' }}>Kuglački klub — sistem za statistike</div>
        </div>

        {korak === 'odabir' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <button onClick={() => setKorak('admin')}
              style={{ padding: '18px', background: '#e94560', color: 'white', border: 'none', borderRadius: '10px', fontSize: '16px', fontWeight: '600', cursor: 'pointer' }}>
              🔐 Prijava kao Admin
            </button>
            <button onClick={handleIgracKorak}
              style={{ padding: '18px', background: '#16162a', color: 'white', border: '1px solid #2a2a4a', borderRadius: '10px', fontSize: '16px', fontWeight: '600', cursor: 'pointer' }}>
              {ucitavanje ? 'Učitavanje...' : '👤 Prijava kao Igrač'}
            </button>
            <button onClick={handleGostLogin}
              style={{ padding: '18px', background: '#16162a', color: '#888899', border: '1px solid #2a2a4a', borderRadius: '10px', fontSize: '16px', fontWeight: '600', cursor: 'pointer' }}>
              👁️ Uđi kao Gost
            </button>
          </div>
        )}

        {korak === 'admin' && (
          <div className="card">
            <div style={{ fontSize: '18px', fontWeight: '700', color: '#fff', marginBottom: '20px' }}>🔐 Admin prijava</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div className="form-group">
                <label>Email</label>
                <input type="email" placeholder="admin@arenabakarni.ba"
                  value={adminEmail} onChange={e => setAdminEmail(e.target.value)} />
              </div>
              <div className="form-group">
                <label>Lozinka</label>
                <input type="password" placeholder="••••••••"
                  value={adminLozinka} onChange={e => setAdminLozinka(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleAdminLogin()} />
              </div>
              {greska && (
                <div style={{ background: 'rgba(233,69,96,0.1)', border: '1px solid rgba(233,69,96,0.3)', borderRadius: '6px', padding: '10px', color: '#e94560', fontSize: '13px' }}>
                  {greska}
                </div>
              )}
              <button className="btn-primary" onClick={handleAdminLogin} disabled={ucitavanje}
                style={{ padding: '12px', fontSize: '15px', opacity: ucitavanje ? 0.7 : 1 }}>
                {ucitavanje ? 'Prijava...' : 'Prijavi se'}
              </button>
              <button className="btn-secondary" onClick={() => { setKorak('odabir'); setGreska(''); }}
                style={{ padding: '10px' }}>← Nazad</button>
            </div>
          </div>
        )}

        {korak === 'igrac' && (
          <div className="card">
            <div style={{ fontSize: '18px', fontWeight: '700', color: '#fff', marginBottom: '20px' }}>👤 Prijava igrača</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div className="form-group">
                <label>Odaberi igrača</label>
                <select value={odabraniIgrac} onChange={e => setOdabraniIgrac(e.target.value)}>
                  <option value="">-- odaberi --</option>
                  {[...igraci].sort((a, b) => a.ime.localeCompare(b.ime)).map(i => (
                    <option key={i.id} value={i.id}>{i.ime} ({i.klub})</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>PIN kod</label>
                <input type="password" placeholder="••••" maxLength="6"
                  value={pin} onChange={e => setPin(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleIgracLogin()} />
              </div>
              {greska && (
                <div style={{ background: 'rgba(233,69,96,0.1)', border: '1px solid rgba(233,69,96,0.3)', borderRadius: '6px', padding: '10px', color: '#e94560', fontSize: '13px' }}>
                  {greska}
                </div>
              )}
              <button className="btn-primary" onClick={handleIgracLogin} disabled={ucitavanje}
                style={{ padding: '12px', fontSize: '15px', opacity: ucitavanje ? 0.7 : 1 }}>
                {ucitavanje ? 'Prijava...' : 'Prijavi se'}
              </button>
              <button className="btn-secondary"
                onClick={() => { setKorak('odabir'); setGreska(''); setPin(''); setOdabraniIgrac(''); }}
                style={{ padding: '10px' }}>← Nazad</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;